module.exports = __webpack_public_path__ + "img/logo-idrc-com-mao-com-texto.0f049962.svg";